<template>
  <div
    class="rounded-full p-2.5 flex justify-center items-center"
    :class="{
      'w-10 h-10': size === 'large',
      'w-7 h-7 text-xs': size === 'small'
    }"
    :style="`background:rgba(${bgColor})`"
  >
    <span class="font-bold" :style="`color:rgba(${textColor})`">
      {{ initials }}
    </span>
  </div>
</template>
<script setup lang="ts">
import type { IUser } from "@/models/users";
import { USER_BADGE_COLORS } from "@/helpers/constants";
import type { PropType } from "vue";
import { computed } from "vue";

type colorIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

const props = defineProps({
  user: {
    type: Object as PropType<
      Partial<IUser> & { first_name: string; last_name: string }
    >
  },
  size: {
    type: String as PropType<"small" | "large">,
    default: "large"
  }
});
const initials = computed(() => {
  const firstInitial = props.user?.first_name.charAt(0) ?? "";
  if (props.user?.last_name) {
    const secondIntial = props.user.last_name.charAt(0);
    return firstInitial + secondIntial;
  }
  return firstInitial;
});

const badgeColor = computed(() => {
  let colorSum = 0;
  if (initials.value?.length > 1) {
    colorSum += initials.value?.charCodeAt(1);
  }
  if (initials.value?.length > 0) {
    colorSum += initials.value?.charCodeAt(0);
  }
  const colorIndex = colorSum % 8;
  return USER_BADGE_COLORS[colorIndex as colorIndex];
});

const bgColor = computed(() => badgeColor.value.background);
const textColor = computed(() => badgeColor.value.text);
</script>
